import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { FcuEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class FcuUnitSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    fcuUnitCreated$() {
        return this.socketService.receiveMessageObserver(FcuEvents.FCU_UNIT_CREATED);
    }

    fcuUnitUpdated$() {
        return this.socketService.receiveMessageObserver(FcuEvents.FCU_UNIT_UPDATED);
    }

    fcuUnitDeleted$() {
        return this.socketService.receiveMessageObserver(FcuEvents.FCU_UNIT_DELETED);
    }

    fcuUnitDuplicate$() {
        return this.socketService.receiveMessageObserver(FcuEvents.FCU_UNIT_DUPLICATED);
    }
}
